import { ContextService } from '../../../services/context_service';
import formStyle from '../style/WForm.less';
import { lazyInject } from '../../../services/inversify';
import { PhotoCapture } from '../../photo/PhotoCapture';
import { PhotoDraw } from '../../photo/PhotoDraw';
import photoStyle from '../../photo/Photo.less';
import * as React from 'react';
import { resizeImage } from '../helpers/resizeImage';
import { WSpinner } from '../../elements/spinner/WSpinner';
import { DataService } from '../../../services/data_service';
import { ApiService } from '../../../services/api_service';

interface WFormFieldFotoProps extends React.ClassAttributes<any> {
    module: string;
    label: JSX.Element;
    name: string;
    fotoName?: string;
    value: string;
    width: number;
    height: number;
    widthCapture?: number;
    heightCapture?: number;
    disableUpload?: boolean;
    required?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    onValueChange(name: string, value: any): void;
}

export interface WFormFieldFotoState extends React.ClassAttributes<any> {
    takePhoto: boolean;
    drawPhoto: boolean;
    facingMode: string;
    fotob64: string;
    realWidth: number;
    realHeight: number;
    canWidth: number;
    canHeight: number;
    imgData: any;
    imgLoaded: boolean;
    disableUpload: boolean;
    loading: boolean;
}

export class WFormFieldFoto extends React.Component<WFormFieldFotoProps, WFormFieldFotoState> {

    constructor(props: any) {
        super(props);
        this.state = {
            // station: props.location.state.station,
            // sachstand: props.location.state.sachstand,
            takePhoto: false,
            drawPhoto: false,
            facingMode: 'environment',
            fotob64: null,
            realWidth: null,
            realHeight: null,
            canWidth: null,
            canHeight: null,
            imgData: null,
            imgLoaded: false,
            disableUpload: this.props.disableUpload ? true : false,
            loading: false
        };
        // this.onInputChange = this.onInputChange.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onCapturePhoto = this.onCapturePhoto.bind(this);
        this.onDeleteFile = this.onDeleteFile.bind(this);
        this.onDrawDone = this.onDrawDone.bind(this);
        this.onDrawPhoto = this.onDrawPhoto.bind(this);
        this.onTakePhoto = this.onTakePhoto.bind(this);
        this.onUploadFile = this.onUploadFile.bind(this);
        this.setCanSize = this.setCanSize.bind(this);

        this.bereichKey = this.apiService.getBereichKey();
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService; // Nur zur Abfrage des Limits
    @lazyInject(ApiService) private apiService: ApiService;

    private refField: any = React.createRef();
    private resizeWidth = 1280;
    private resizeHeight = 1024;
    private bereichKey: string;

    componentDidMount() {
        this.setCanSize();
        this.setResizeDefault();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.value !== prevProps.value) {
            this.setState(
                { fotob64: null, imgData: null, realWidth: null, realHeight: null, canWidth: null, canHeight: null, imgLoaded: false },
                () => this.setCanSize()
            );
        }
    }

    drawPhoto() {
        const conf = require('../../../wips.config.js');

        if (this.state.canWidth && this.state.canHeight) {
            const imageURL = this.props.value ? (conf.image_base_url + this.props.value + "&bereich_key=" + this.bereichKey) : undefined;
            return (
                <div className={photoStyle.outerBox}>
                    <PhotoDraw
                        imageData={this.state.imgData}
                        imageURL={imageURL}
                        onCloseDraw={() => this.setState({ drawPhoto: false })}
                        width={this.state.canWidth}
                        height={this.state.canHeight}
                        realWidth={this.state.realWidth}
                        realHeight={this.state.realHeight}
                        name={this.props.name}
                        onDrawDone={this.onDrawDone}
                    />
                </div>
            );
        }
    }

    onCancel() {
        const takePhoto = false;
        this.setState({ takePhoto });
    }

    onCapturePhoto(fotob64: string, uploadName?: string) {
        // console.log(fotob64);
        const takePhoto = false;
        this.setState({ takePhoto, fotob64 }, () => {
            this.setCanSize();
        });
        const fieldName = uploadName ? uploadName : this.props.name;
        const b64 = fotob64.substring(fotob64.indexOf(',') + 1);
        this.props.onValueChange(fieldName, 0);
        this.props.onValueChange(`${fieldName}_archiv_rawdata`, b64);
        this.props.onValueChange(`${fieldName}_archiv_filename`, fieldName);
    }

    onDeleteFile() {
        if (!window.confirm('Foto löschen?')) {
            return;
        }
        const fieldName: string = this.props.name;
        this.props.onValueChange(this.props.name, null);
        this.props.onValueChange(`${fieldName}_archiv_rawdata`, null);
        this.props.onValueChange(`${fieldName}_archiv_filename`, fieldName);
    }

    onDrawDone(fotob64: string) {
        const drawPhoto = false;
        this.setState({ drawPhoto, fotob64 }, () => {
            this.setCanSize();
        });
        const fieldName = this.props.name;
        const b64 = fotob64.substring(fotob64.indexOf(',') + 1);
        this.props.onValueChange(fieldName, 0);
        this.props.onValueChange(`${fieldName}_archiv_rawdata`, b64);
        this.props.onValueChange(`${fieldName}_archiv_filename`, fieldName);
    }

    onDrawPhoto() {
        this.setState({ drawPhoto: true });
    }

    onTakePhoto(facingMode: string) {
        const takePhoto = true;
        this.setState({ takePhoto, facingMode });
    }

    onUploadFile(evt: any) {
        const file = evt.target.files[0];
        // console.log('File: ', file);
        if (this.dataService.fileSizeCheck && file.size >= this.dataService.fileSizeLimit) {
            alert('Bitte verwenden Sie nur Bilder mit einer maximalen Größe von ' + this.dataService.fileSizeInfo);
            this.setState({ loading: false });
            return;
        }

        // console.log(file);
        const fieldName = evt.target.name;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onerror = (error) => {
            console.error(error);
        };
        reader.onload = (event: any) => {
            const img64 = event.target.result;
            // this.setState({ fotob64: img64 });
            // this.onCapturePhoto(img64);
            resizeImage(img64, (rszImg64: string) => {
                this.setState({ fotob64: rszImg64, loading: false });
                this.onCapturePhoto(rszImg64, fieldName);
            }, this.resizeWidth, this.resizeHeight, file);
        };
    }

    render(): JSX.Element {
        if (!this.state.imgLoaded || this.state.loading) {
            return <WSpinner />;
        }
        const conf = require('../../../wips.config.js');
        /*const imgSrc = this.state.fotob64
            ? this.state.fotob64
            : this.props.value ? conf.image_base_url + this.props.value : undefined;*/
        let imgW = this.props.width;
        let imgH = this.props.height;

        if (this.state.realWidth > 0 && this.state.realHeight > 0) {
            if (this.state.realWidth > this.state.realHeight) {
                imgW = this.props.width;
                imgH = imgW * this.state.realHeight / this.state.realWidth;
            } else {
                imgH = this.props.height;
                imgW = imgH * this.state.realWidth / this.state.realHeight;
            }
            // console.log(imgW, imgH);
        }

        return (
            <div
                ref={this.refField}
                className={formStyle.fieldBox}
            >
                {this.props.label}
                {this.state.takePhoto
                    ?
                    (
                        <div className={photoStyle.outerBox}>
                            <PhotoCapture
                                width={this.resizeWidth}
                                height={this.resizeHeight}
                                widthCapture={this.resizeWidth}
                                heightCapture={this.resizeHeight}
                                facingMode={this.state.facingMode}
                                onCapture={(fotob64: string) => {
                                    resizeImage(fotob64, (rszImg64: string) => {
                                        this.setState({ fotob64: rszImg64, loading: false });
                                        this.onCapturePhoto(rszImg64);
                                    }, this.resizeWidth, this.resizeHeight);
                                }}
                                onCancel={this.onCancel}
                            />
                        </div>
                    )
                    : this.state.drawPhoto
                        ? this.drawPhoto()
                        :
                        <div className={formStyle.input}>
                            {this.state.imgLoaded
                                ? this.state.imgData &&
                                <div className={photoStyle.videocanvasparent} style={{ textAlign: 'center' }}>
                                    <img
                                        style={{
                                            width: imgW,
                                            height: imgH,
                                            maxWidth: 200,
                                            maxHeight: 160
                                        }}
                                        src={this.state.imgData}
                                        alt='Foto'
                                    />
                                </div>
                                : <WSpinner />
                            }
                            {this.state.imgLoaded &&
                                <div className={photoStyle.icondiv}>
                                    {this.renderIcons()}
                                </div>
                            }
                        </div>
                }
            </div>
        );
    }

    renderIcons(): Array<JSX.Element> {
        const disabled = this.props.readonly || this.props.disabled ? true : false;
        const iconCamera = require('../../../icons/icons8-google-bilder.svg');
        const iconDelete = require('../../../icons/icons8-trash.svg');
        const iconDownload = require('../../../icons/icons8-save.png');
        const iconUpload = require('../../../icons/icons8-cloud_upload.svg');
        const iOS = window.navigator.platform === 'iPhone';
        const icons: Array<JSX.Element> = [
            <div style={{ display: 'inline-block' }}>
                <img
                    className={formStyle.iconsvg}
                    onClick={() => disabled
                        ? alert('Foto kann nicht geändert werden!')
                        : this.onTakePhoto('environment')
                    }
                    src={iconCamera}
                    title='Kamera öffnen'
                    alt='Kamera'
                />
                <div style={{ margin: '0 5px' }}>{'\n'}Foto machen</div>
            </div>,
            <div style={{ display: 'inline-block' }}>
                <label htmlFor={this.props.name}>
                    <img
                        className={formStyle.iconsvg}
                        src={iconCamera}
                        title='Kamera öffnen'
                        alt='Kamera'
                    />
                    <div style={{ margin: '0 5px' }}>{'\n'}Foto machen</div>
                </label>
                <input
                    style={{ display: 'none' }}
                    id={this.props.name}
                    type='file'
                    name={this.props.name}
                    accept='image/png, image/jpeg'
                    capture
                    onChange={(e: any) => {
                        this.setState({ loading: true });
                        this.onUploadFile(e);
                    }}
                />
            </div>,
            <img
                className={formStyle.iconsvg}
                src='src/icons/icons8-draw.png'
                onClick={() => disabled
                    ? alert('Foto kann nicht geändert werden!')
                    : this.onDrawPhoto()
                }
                title='Foto bearbeiten'
                alt='bearbeiten'
            />,
            <div style={{ display: 'inline-block' }}>
                <label htmlFor={this.props.name}>
                    <img
                        className={formStyle.iconsvg}
                        src={iconUpload}
                        title='Foto hochladen'
                        alt='hochladen'
                    />
                    <div style={{ margin: '0 5px' }}>{'\n'}Datei-Upload</div>
                </label>
                <input
                    style={{ display: 'none' }}
                    id={this.props.name}
                    type='file'
                    accept='image/png, image/jpeg'
                    name={this.props.name}
                    onChange={(e: any) => {
                        this.setState({ loading: true });
                        this.onUploadFile(e);
                    }}
                />
            </div>,
            <a
                href={this.state.imgData}
                style={{ cursor: 'pointer' }}
                download={`${this.props.fotoName}.jpg`}
            >
                <img
                    className={formStyle.iconsvg}
                    src={iconDownload}
                    title='Foto herunterladen'
                    alt='herunterladen'
                />
            </a>,
            <div style={{ display: 'inline-block' }}>
                <img
                    className={formStyle.iconsvg}
                    src={iconDelete}
                    onClick={this.onDeleteFile}
                    title='Foto löschen'
                    alt='löschen'
                />
                <div style={{ margin: '0 5px' }}>{'\n'}Foto löschen</div>
            </div>
        ];
        const capture: JSX.Element = iOS ? icons[1] : icons[0];
        const del: JSX.Element = this.state.imgData ? icons[5] : null;
        const upload: JSX.Element = this.state.disableUpload ? null : icons[3];

        return [upload, capture, del]
            .map((icon: any, index: number) =>
                <React.Fragment key={`icon-${index}`}>{icon}</React.Fragment>
            );
    }

    async setCanSize() {
        let canWidth = window.innerWidth - 20;
        let canHeight = canWidth / 0.75;

        if (window.innerWidth > window.innerHeight) {
            canHeight = window.innerHeight - 150;
            canWidth = Math.min(window.innerWidth, canHeight / 0.75);
        }
        const conf = require('../../../wips.config.js');
        const imageData = this.state.fotob64;
        const imageURL = this.props.value ?
            (conf.image_base_url + this.props.value + "&bereich_key=" + this.bereichKey + "&module=" + this.props.module)
            : undefined;
        // console.log(imageURL);
        const imgSrc = imageData ? imageData : imageURL;
        const blob = await fetch(imgSrc).then((r) => r.blob());
        const reader = new FileReader();
        const that = this;
        let realWidth = canWidth;
        let realHeight = canHeight;
        let imgData: any = null;
        reader.readAsDataURL(blob);
        reader.onloadend = function (e: any) {
            imgData = e.target.result.replace('data:text/plain;charset=utf-8;base64,', 'data:image/jpeg;base64,');

            if (imgData && imgData === '') {
                imgData = undefined;
            }
            const img = new Image();
            img.src = imgData;
            img.onload = () => {
                // console.log(img.width, img.height);
                realWidth = img.width;
                realHeight = img.height;
                const imgRatio = realWidth / realHeight;

                if (realWidth > realHeight) {
                    if (canWidth > realWidth) {
                        canWidth = realWidth;
                        canHeight = realHeight;
                    } else {
                        canHeight = canWidth / imgRatio;
                    }
                } else {
                    if (canHeight > realHeight) {
                        canHeight = realHeight;
                        canWidth = realWidth;
                    } else {
                        canWidth = canHeight * imgRatio;
                    }
                }
                that.setState({ realWidth, realHeight, canWidth, canHeight, imgData, imgLoaded: true });
            };
            img.onerror = () => that.setState({ realWidth, realHeight, canWidth, canHeight, imgLoaded: true });
        };
        reader.onerror = function (e: any) {
            that.setState({ imgLoaded: true });
        };
    }

    setResizeDefault() {
        const size: number = (((this.contextService.get('systemparameter') || [])
            .find((item: any) => item.parameter === 'max_bildgroesse')) || {}).wert || null;
        if (+size > 0) {
            this.resizeWidth = +size;
            this.resizeHeight = +size;
        }
    }
}
